'use client';

export default function GlobalError({ reset }: { reset: () => void }) {
  // fetch('/api/client-log', {
  //   method: 'POST',
  //   headers: {'Content-Type':'application/json'},
  //   body: JSON.stringify({ type:'global-error', message: error.message, stack: error.stack }),
  // }).catch(() => {});
  return (
    <html><body>
      <h2>Critical error</h2>
      <button onClick={() => reset()}>Reload</button>
    </body></html>
  );
}
